import { render } from "./UserMenu.vue?vue&type=template&id=2446782e&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=2446782e&lang=scss&scoped=true"

import exportComponent from "/var/www/appp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2446782e"]])

export default __exports__